module.exports = __webpack_public_path__ + "img/GA.dd50a905.svg";